<div
	class="office-icon"
	style="display: flex; align-items: center; justify-content: center"
	[style.color]="color"
	[style.width]="size + 'px'"
	[style.height]="size + 'px'"
>
	<!-- chevron-down -->
	<svg
		*ngIf="name === 'chevron-down'"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		width="24"
		height="24"
	>
		<path
			fill="currentColor"
			d="M4.7 6.9a.5.5 0 00-.8.6l7.7 9.6c.2.2.6.2.8 0L20 7.5a.5.5 0 10-.8-.6L12 16 4.7 7z"
		/>
	</svg>
	<!-- /chevron-down -->
	<!-- close -->
	<svg
		*ngIf="name === 'close'"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		width="24"
		height="24"
	>
		<path
			fill="currentColor"
			d="m11.85858,11.05858l6.2,-6.2a0.6,0.6 0 0 1 0.8,0.8l-6.2,6.2l6.2,6.2a0.6,0.6 0 1 1 -0.8,0.8l-6.2,-6.2l-6.2,6.2a0.6,0.6 0 0 1 -0.8,-0.8l6.2,-6.2l-6.2,-6.2a0.6,0.6 0 0 1 0.8,-0.8l6.2,6.2z"
		/>
	</svg>
	<!-- /close -->
	<!-- close-circle -->
	<svg
		*ngIf="name === 'close-circle'"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		width="24"
		height="24"
	>
		<path
			fill="currentColor"
			stroke="null"
			d="M12 2.13a9.87 9.87 0 100 19.74 9.87 9.87 0 000-19.74zm4.87 12.56v.64l-1.66 1.54c-.26.26-.52.26-.77 0l-2.57-2.56-2.56 2.56c-.26.26-.52.26-.77 0L7 15.33c-.26-.25-.26-.5 0-.77L9.56 12 7 9.44c-.26-.26-.26-.52 0-.77l1.54-1.54h.77l2.56 2.56 2.57-2.56h.77l1.53 1.54v.77L14.18 12l2.56 2.56.13.13z"
		/>
	</svg>
	<!-- /close-circle -->
	<!-- search -->
	<svg
		*ngIf="name === 'search'"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		width="24"
		height="24"
	>
		<path
			fill="currentColor"
			fill-rule="evenodd"
			d="M5.268 16.797a8.153 8.153 0 0011.18.329l.008.008 3.837 3.837c.452.452 1.13-.226.678-.678l-3.837-3.837-.008-.008a8.153 8.153 0 10-11.858.349zm10.85-10.851A7.193 7.193 0 115.947 16.119 7.193 7.193 0 0116.119 5.946z"
			clip-rule="evenodd"
		/>
	</svg>
	<!-- /search -->
	<!-- done, check -->
	<svg
		*ngIf="name === 'done' || name === 'check'"
		width="18"
		height="13"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M1.62 7.545a.48.48 0 00-.6.75l4.8 3.84a.48.48 0 00.64-.036L17.02 1.54a.48.48 0 00-.68-.678L6.085 11.117 1.62 7.545z"
			fill="#495057"
		/>
	</svg>
	<!-- /done, /check -->
	<!-- done-circle, check-circle -->
	<svg
		*ngIf="name === 'done-circle' || name === 'check-circle'"
		width="14"
		height="14"
		viewBox="0 0 14 14"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M7 1.5C3.96243 1.5 1.5 3.96243 1.5 7C1.5 10.0376 3.96243 12.5 7 12.5C10.0376 12.5 12.5 10.0376 12.5 7C12.5 3.96243 10.0376 1.5 7 1.5ZM0.5 7C0.5 3.41015 3.41015 0.5 7 0.5C10.5899 0.5 13.5 3.41015 13.5 7C13.5 10.5899 10.5899 13.5 7 13.5C3.41015 13.5 0.5 10.5899 0.5 7Z"
			fill=" var(--brand-color-pure)"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M9.35355 5.31295C9.54882 5.50821 9.54882 5.8248 9.35355 6.02006L6.68689 8.68672C6.49162 8.88199 6.17504 8.88199 5.97978 8.68672L4.64645 7.35339C4.45118 7.15813 4.45118 6.84155 4.64645 6.64628C4.84171 6.45102 5.15829 6.45102 5.35355 6.64628L6.33333 7.62606L8.64645 5.31295C8.84171 5.11769 9.15829 5.11769 9.35355 5.31295Z"
			fill=" var(--brand-color-pure)"
		/>
	</svg>
	<!-- /done-circle, /check-circle -->
	<!-- alert -->
	<svg
		*ngIf="name === 'alert'"
		width="24"
		height="24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zM12 8v4M12 16h.01"
			stroke="#FED223"
			stroke-width="1.5"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>

	<svg
		*ngIf="name === 'messages'"
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M9 1.75C8.86193 1.75 8.75 1.86193 8.75 2V8C8.75 8.13807 8.86193 8.25 9 8.25H16C16.1989 8.25 16.3897 8.32902 16.5303 8.46967L18.25 10.1893V2C18.25 1.86193 18.1381 1.75 18 1.75H9ZM19.75 12V2C19.75 1.0335 18.9665 0.25 18 0.25H9C8.0335 0.25 7.25 1.0335 7.25 2V8C7.25 8.9665 8.0335 9.75 9 9.75H15.6893L18.4692 12.5298C18.471 12.5316 18.4728 12.5334 18.4746 12.5352M19.5254 12.5352C19.4547 12.6047 19.3735 12.6573 19.2871 12.6931C19.1987 12.7298 19.1017 12.75 19 12.75C18.8983 12.75 18.8013 12.7298 18.7129 12.6931C18.6265 12.6573 18.5453 12.6047 18.4746 12.5352M19.6931 12.2871C19.6573 12.3735 19.6047 12.4547 19.5352 12.5254C19.532 12.5287 19.5287 12.532 19.5254 12.5352M19.6931 12.2871C19.7298 12.1987 19.75 12.1017 19.75 12L19.6931 12.2871Z"
			fill=" var(--brand-color-pure)"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M2 8.75C1.86193 8.75 1.75 8.86193 1.75 9V17.1893L3.46967 15.4697C3.61032 15.329 3.80109 15.25 4 15.25H11C11.1381 15.25 11.25 15.1381 11.25 15V13C11.25 12.5858 11.5858 12.25 12 12.25C12.4142 12.25 12.75 12.5858 12.75 13V15C12.75 15.9665 11.9665 16.75 11 16.75H4.31066L1.53033 19.5303C1.31583 19.7448 0.993243 19.809 0.712987 19.6929C0.432732 19.5768 0.25 19.3033 0.25 19V9C0.25 8.0335 1.0335 7.25 2 7.25H4C4.41421 7.25 4.75 7.58579 4.75 8C4.75 8.41421 4.41421 8.75 4 8.75H2Z"
			fill=" var(--brand-color-pure)"
		/>
	</svg>

	<!-- /alert -->
</div>
